module.exports = __webpack_public_path__ + "static/media/(V)_MG_6286_-_Joias_Contenporaneas.9b4014db.jpg";